import React, { useState } from 'react'
import './NavbarDashboard.css'
import { Link as Anchor, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faUsers, faBook, faImage, faAddressBook, faTachometerAlt, faTags, faClipboardList, faMoneyBill, faIdCard, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../images/logo.png'
import Logout from '../Logout/Logout';

const NAV_LINKS = [
    { to: '/dashboard',              icon: faHome,           label: 'Inicio' },
    { to: '/dashboard/productos',    icon: faBook,           label: 'Productos' },
    { to: '/dashboard/pedidos',      icon: faClipboardList,  label: 'Pedidos' },
    { to: '/dashboard/categorias',   icon: faTachometerAlt,  label: 'Categorias' },
    { to: '/dashboard/banners',      icon: faImage,          label: 'Banners' },
    { to: '/dashboard/contacto',     icon: faAddressBook,    label: 'Contacto' },
    { to: '/dashboard/pasarelaPagos',icon: faMoneyBill,      label: 'Pasarelas de Pagos' },
    { to: '/dashboard/usuarios',     icon: faUser,           label: 'Usuarios' },
    { to: '/dashboard/clientes',     icon: faUsers,          label: 'Clientes' },
    { to: '/dashboard/tiposCliente', icon: faIdCard,         label: 'Tipos de Cliente' },
    { to: '/dashboard/codigos',      icon: faTags,           label: 'Cupones' },
];

export default function Navbar() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    const isActive = (to) => location.pathname === to;

    return (
        <>
            {/* Overlay para cerrar menú en móvil */}
            {menuOpen && (
                <div className="navbarDashboard-overlay" onClick={() => setMenuOpen(false)} />
            )}

            <div className={`navbarDashboard${menuOpen ? ' navbarDashboard--open' : ''}`}>
                {/* Header: logo + hamburger */}
                <div className="navbarDashboard-header">
                    <Anchor className='logo' to="/dashboard">
                        <img src={logo} alt="logo" />
                    </Anchor>
                    <button
                        className="navbarDashboard-hamburger"
                        onClick={() => setMenuOpen(v => !v)}
                        aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
                    >
                        <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
                    </button>
                </div>

                {/* Links */}
                <div className='links' onClick={() => setMenuOpen(false)}>
                    {NAV_LINKS.map(({ to, icon, label }) => (
                        <Anchor
                            key={to}
                            to={to}
                            className={isActive(to) ? 'activeLink' : ''}
                        >
                            <FontAwesomeIcon icon={icon} /> {label}
                        </Anchor>
                    ))}
                </div>

                <Logout />
            </div>
        </>
    );
}
